import { SEO } from "@/components/SEO";
import { Action, FreePlanCTA } from "@/components/marketing/Marketing";
export default function ServicesPage() {
  return (
    <div className="growth">
      <SEO
        title="AI and automation services for your business"
        description="Lead generation, follow-up, AI email assistance, marketing workflows, and custom business systems. Scoped monthly services from $500."
        url="https://www.bettersystems.ai/services"
      />
      <section className="hero">
        <div className="wrap">
          <span className="eyebrow">What we do</span>
          <h1>
            Let AI do more.
            <br />
            <em>Let your business grow.</em>
          </h1>
          <p className="intro">
            We help you attract customers, turn interest into sales, and take
            repetitive work off your team. Start with the problem that matters
            most.
          </p>
          <div className="actions">
            <Action href="/contact">Tell us what you need</Action>
          </div>
        </div>
      </section>
      <section className="section" style={{ paddingTop: 20 }}>
        <div className="wrap">
          <div className="tiles">
            {[
              [
                "Bring in more opportunities",
                "Lead capture, landing pages, prospect research, and marketing workflows designed around the customers you want.",
                [
                  "Lead generation systems",
                  "Landing pages & lead forms",
                  "Campaign tracking & reporting",
                ],
              ],
              [
                "Follow up while you work",
                "Put a repeatable follow-up process behind your inbox, calls, and sales pipeline.",
                [
                  "AI-assisted email responses",
                  "CRM setup & follow-up sequences",
                  "Appointment & estimate reminders",
                ],
              ],
              [
                "Improve your marketing",
                "Use AI to help develop ad ideas, test messages, and make decisions from campaign results.",
                [
                  "Ad creative & copy support",
                  "Offer and audience experiments",
                  "Lead-quality reviews",
                ],
              ],
              [
                "Cut the daily admin",
                "Connect the information your team keeps typing, copying, and asking for.",
                [
                  "Document & report workflows",
                  "Quotes, invoices & notifications",
                  "Tool integrations",
                ],
              ],
              [
                "Build tools your team will use",
                "Custom web and mobile apps built around how work happens in your business.",
                [
                  "Sales & field apps",
                  "Customer & employee portals",
                  "Scheduling & job workflows",
                ],
              ],
              [
                "See the whole operation",
                "Bring the important parts of the business together so the owner can spot what needs attention.",
                [
                  "Owner dashboards",
                  "Daily summaries & exception alerts",
                  "Business operating systems",
                ],
              ],
            ].map(([title, body, items], i) => (
              <article className="tile" key={title as string}>
                <span className="number">0{i + 1}</span>
                <h3>{title}</h3>
                <p>{body}</p>
                <ul className="clean">
                  {(items as string[]).map((x) => (
                    <li key={x}>{x}</li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </div>
      </section>
      <section className="section dark">
        <div className="wrap split">
          <div>
            <span className="eyebrow">Start with a focused scope</span>
            <h2>$500–$1,500 / month</h2>
            <p className="intro">
              An initial range for focused, ongoing AI and automation services.
              The right scope depends on your goals, current tools, and the work
              we take on.
            </p>
            <Action href="/contact">Find the right starting point</Action>
          </div>
          <div>
            <h3>Know what you’re paying for.</h3>
            <ul className="clean">
              <li>Written deliverables and responsibilities</li>
              <li>A clear measure of progress</li>
              <li>Agreed support and improvement work</li>
              <li>
                Setup, custom builds, software, and ad spend quoted separately
              </li>
            </ul>
            <p className="small" style={{ marginTop: 20 }}>
              Larger implementations and broader ongoing work are priced
              separately. We agree on the scope before starting.
            </p>
          </div>
        </div>
      </section>
      <FreePlanCTA />
    </div>
  );
}
